import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "personal-center-card__item personal-center-card__item--access personal-center-card__item--multi" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"personal-center-card__item--hd\">作品提交</div><div class=\"personal-center-card__item--tips\"><div class=\"personal-center-card__item--tips-line\">比赛前需仔细阅读赛题说明，按照每个赛道要求提交结果文件。</div><div class=\"personal-center-card__item--tips-line\"> 每个赛道初赛、复赛阶段结束前，需提交最高得分对应的原始文件（包含代码和模型文件）供评委审核。 </div><div class=\"personal-center-card__item--tips-line\">原始文件审核通过，且验证评分与最高得分误差在5%以内，才能有效进入排名和获奖。</div></div>", 2)
const _hoisted_4 = { class: "personal-center-card__item__ft" }
const _hoisted_5 = { class: "ft-left" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 此赛道今日还可提交作品次数：")
const _hoisted_7 = { class: "ft-right" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("点击可以将目前存储的作品结果提交审核并打分。")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("提交作品")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("点击将目前存储的模型标注结果回传到数据中心，")
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode("影像页中可显示标注结果。")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("标注回传")
const _hoisted_14 = ["href"]
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 赛道详情 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WorkListTable = _resolveComponent("WorkListTable")!
  const _component_TabPane = _resolveComponent("TabPane")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Tooltip = _resolveComponent("Tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_Tabs, {
      modelValue: _ctx.activeName,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeName) = $event)),
      onTabClick: _ctx.handleTab
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.channels, (item, index) => {
          return (_openBlock(), _createBlock(_component_TabPane, {
            label: item.CharName,
            name: `${index}`,
            key: item.Id
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.step, (i) => {
                  return (_openBlock(), _createBlock(_component_WorkListTable, {
                    Step: i,
                    ChannelId: item.Id,
                    key: i,
                    ref_for: true,
                    ref: `tablelist${index}${i}`
                  }, null, 8, ["Step", "ChannelId"]))
                }), 128))
              ])
            ]),
            _: 2
          }, 1032, ["label", "name"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue", "onTabClick"]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.curChannel?.Title), 1),
        _createElementVNode("p", null, [
          _hoisted_6,
          _createElementVNode("span", null, _toDisplayString(_ctx.isInContest && _ctx.canSubmit ? _ctx.upTimes : 0), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_Tooltip, { placement: "top" }, {
          content: _withCtx(() => [
            _hoisted_8
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Button, {
              type: "primary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.submitWorks(2))),
              disabled: ""
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_Tooltip, { placement: "top" }, {
          content: _withCtx(() => [
            _hoisted_10,
            _hoisted_11,
            _hoisted_12
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Button, {
              plain: "",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.submitWorks(1))),
              disabled: ""
            }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("a", {
          href: `./channelDetail?id=${_ctx.curChannel?.Id}`,
          target: "_blank"
        }, [
          _createVNode(_component_Button, {
            plain: "",
            class: "t-default"
          }, {
            default: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          })
        ], 8, _hoisted_14)
      ])
    ])
  ]))
}